import { render, staticRenderFns } from "./htmlEdit.vue?vue&type=template&id=89e280c2&"
import script from "./htmlEdit.vue?vue&type=script&lang=js&"
export * from "./htmlEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports